// extracted by mini-css-extract-plugin
export default {"datepicker":"Datepicker_datepicker__fwavc","label":"Datepicker_label__VIsBG","labelInner":"Datepicker_labelInner__AX2U2"};